import { isGrantedAny, role } from "shared/src/roles.mjs";
import { getClientProblem } from "../../Client.jsx";

export const useClientProblem = (client, roles) => {
  const perms = {
    canSeeRequiresCzechSpeaker: isGrantedAny(
      roles,
      new Set([
        role.Floor_Manager,
        role.Back_Office,
        role.Front_Office,
        role.Manager_Clinic,
        role.Manager_Customer_Care,
        role.Read_Only_Full,
      ]),
    ),
    canSeeDoctorNecessary: isGrantedAny(
      roles,
      new Set([
        role.Floor_Manager,
        role.Back_Office,
        role.Front_Office,
        role.Dental_Assistant,
        role.Manager_Clinic,
        role.Manager_Customer_Care,
        role.Read_Only_Full,
      ]),
    ),
  };

  return getClientProblem(client, perms);
};
